import { render } from "./ItemList.vue?vue&type=template&id=8715626a"
import script from "./ItemList.vue?vue&type=script&lang=js"
export * from "./ItemList.vue?vue&type=script&lang=js"

import "./ItemList.vue?vue&type=style&index=0&id=8715626a&lang=less"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__